import { motion, useReducedMotion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { Link } from "react-router-dom";
import { COCKPIT } from "../../constants/testIds";
import { fadeUp } from "../../lib/motion";

// UI_STANDARDS.md Part A: "no data yet" is a distinct state from "no results for filter" — this
// is specifically the brand-new-gym case (zero members yet), never shown for an empty filter.
export function EmptyCockpitState() {
  const reducedMotion = useReducedMotion();
  return (
    <motion.div {...fadeUp(reducedMotion)} className="solid-surface rounded-[14px] p-12 flex flex-col items-center text-center" data-testid={COCKPIT.emptyState}>
      <motion.div
        initial={reducedMotion ? { scale: 1, opacity: 1 } : { scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={reducedMotion ? { duration: 0 } : { delay: 0.1, type: "spring", stiffness: 260, damping: 20 }}
        className="w-14 h-14 rounded-full flex items-center justify-center mb-4"
        style={{ background: "var(--scarlet-accent-tint)" }}
      >
        <Sparkles size={24} style={{ color: "var(--scarlet-accent)" }} />
      </motion.div>
      <h3 className="font-bold text-lg mb-1" style={{ color: "var(--scarlet-text)" }}>No data yet — let's finish setup</h3>
      <p className="text-sm max-w-md mb-6" style={{ color: "var(--scarlet-text-secondary)" }}>
        Your gym is provisioned but has no members yet. Add your first branch details, a plan, and your first member to see your cockpit come alive.
      </p>
      <div className="flex gap-3">
        <Link to="/app/branches" className="text-sm font-semibold px-4 py-2 rounded-[10px] text-white" style={{ background: "var(--scarlet-accent)" }}>Set up branches</Link>
        <Link to="/app/plans" className="text-sm font-semibold px-4 py-2 rounded-[10px]" style={{ border: "1px solid var(--scarlet-hairline)", color: "var(--scarlet-text)" }}>Create a plan</Link>
      </div>
    </motion.div>
  );
}
